export enum ThemeNames {
  Default = 'default',
  BluePulse = 'blue-pulse',
  YellowIndigo = 'yellow-indigo',
}
